import React from 'react'
import { useState } from 'react'
import fetch from 'isomorphic-unfetch'
import { useForm } from 'react-hook-form'
// import { ErrorMessage } from 'react-hook-form'
import { Form, Button } from 'react-bootstrap'
import UploadPage from './UploadImage'
// import SlateForm from './SlateForm'

const FormTemplate = () => {
    const [submitted, setSubmitted] = useState(false)
    const { formState, register,handleSubmit } = useForm()
    // const { errors} = useForm()
    const { isSubmitting } = formState

    const onSubmit = async ({ title, category, body }) => {
        console.log(title)
        console.log(category)
        console.log(body)
        const slug = title.toLowerCase().replace(/ /g, '-') || title

        try {
            const response =  await fetch('/.netlify/functions/submitform', {
                method: 'POST',
                body: JSON.stringify({ title, category, slug, body })
            })
      
            console.log(response)
            setSubmitted(true);
          } catch (err) {
            console.log(err)
          }
    }

    // function onFileSelect(e) {
    //     let file = e.target.files[0];
    //     if (file) {
    //       const reader = new FileReader(file);
    //       reader.readAsDataURL(file);
    //       reader.onload = () => {
    //         // set image and base64'd image data in component state
    //         this.setState({
    //           data: reader.result,
    //           file: file
    //         });
    //       }
    //     }
    //   }

    // if (submitted) return <p>Review submitted. Thank you!</p>

    // ref={register({ required: 'Title is required' })}

    return (
        <>
        <Form className="container" onSubmit={handleSubmit(onSubmit)}>
            <Form.Group controlId="exampleForm.ControlInput1">
                <Form.Label>Title</Form.Label>
                <Form.Control
                    name="title"
                    type="text"
                    placeholder="Normal text"
                    ref={register}
                />
            </Form.Group>

            <Form.Group controlId="exampleForm.ControlSelect2">
                <Form.Label>Category</Form.Label>
                <Form.Control
                    as="select"
                    multiple
                    name="category"
                    ref={register}
                >
                    <option>features</option>
                    <option>lifestyle</option>
                    <option>music</option>
                    <option>trending</option>
                    <option>videos</option>
                </Form.Control>
            </Form.Group>

            <Form.Group controlId="exampleForm.ControlTextarea1">
                <Form.Label>Body</Form.Label>
                <Form.Control
                    name="body"
                    as="textarea"
                    rows="3"
                    ref={register}
                />
            </Form.Group>

            <Button variant="primary" type="submit" disabled={isSubmitting}>
                Submit
            </Button>
        </Form>

        {submitted ? <p>Post submitted. Thank you!</p> : ''}
        </>
    )
}

export default FormTemplate
export {UploadPage}